//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmail, isTextWithoutNumbers } from '~/utils/utils';
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    dataType: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    offValidate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passwordHidden: true,
      error: null,
      firstShow: true
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.value)
        },
        blur: (event) => {
          if(!event.target.value) {
            this.error = this.$t('input.notFilledError')
          } else {
            this.error = this.checkErrors
          }
          this.$emit('validate', this.firstShow ? false : !this.error)
        },
        focus: () => {
          this.error = null
          this.firstShow = false
        }
      }
    },
    hasValue () {
      return !!this.value
    },
    checkErrors() {
      switch(this.dataType) {
        case 'email':
          return isEmail(this.value) ? null : this.$t('input.wrongFormatError')
        case 'password':
          return this.value.length > 5 ? null : this.$t('input.min6CharsError')
        case 'name':
        case 'surname':
          return isTextWithoutNumbers(this.value) ? null : this.$t('input.lettersOnlyError')
        case 'sum':
          return Number(this.value.replace(/\s/g, '')) >= 100 ? null : this.$t('input.min100rubError')
        case 'holidaySum':
          return Number(this.value.replace(/\s/g, '')) >= 500 ? null : this.$t('input.min100rubError').replace('100', '500')
        case 'patronSumm':
          return Number(this.value.replace(/\s/g, '')) >= 5000 ? null : this.$t('input.min3000rubError')
        default:
          return null
      }
    },
  }
}
